import { useTranslation } from 'react-i18next';
import { Divider } from '@components/divider';

import { BackButton } from './components/back-button';
import { CompanyHeader } from './components/company-header';
import { FooterButtonsSkeleton } from './components/footer-buttons-skeleton';
import { InputFieldSkeleton } from './components/input-field-skeleton';

export const AddVenueSkeleton = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className='flex justify-center'>
        <div className='w-full md:w-[850px]'>
          <button className='rounded-full w-max mb-4 md:mb-6 px-4 md:px-0' type='button' aria-label='Menu'>
            <BackButton />
          </button>
        </div>
      </div>
      <div className='flex justify-center'>
        <div className='flex justify-start w-[630px] flex-col mb-5 md:mb-40'>
          <CompanyHeader />

          <section>
            <h2 className='text-headline-m text-primary pb-6'>
              <div className='w-48 h-6 bg-tertiary rounded-sm animate-pulse' />
            </h2>
            <div className='grid items-start grid-cols-1 gap-4'>
              <InputFieldSkeleton label={t('newVenue:publicNameLabel')} htmlFor='publicName' />
              <InputFieldSkeleton label={t('newVenue:addressLabel')} htmlFor='address' />
              <InputFieldSkeleton label={t('newVenue:cityLabel')} htmlFor='city' />
              <InputFieldSkeleton label={t('newVenue:countryLabel')} htmlFor='country' />
            </div>
          </section>

          <Divider className='my-10' />

          <section>
            <h2 className='text-headline-m text-primary pb-6'>
              <div className='w-32 h-6 bg-tertiary rounded-sm animate-pulse' />
            </h2>
            <div className='grid items-start grid-cols-1 gap-4'>
              <InputFieldSkeleton label={t('newVenue:instagramLabel')} htmlFor='instagram' />
              <InputFieldSkeleton label={t('newVenue:websiteLabel')} htmlFor='website' />
              <InputFieldSkeleton label={t('newVenue:googleMapsUrlLabel')} htmlFor='googleMapsUrl' />
            </div>
          </section>
        </div>
      </div>
      <FooterButtonsSkeleton />
    </>
  );
};
